import React, {Component} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import {Hidden} from "@irati/ui/src/FormItem"

export const PROPERTY = "runCount"
const CUSTOM_RUN_COUNT_VALUE = 1

class CustomPeriodValue extends Component {
  static propTypes = {
    cycle: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }

  componentDidUpdate() {
    const {cycle} = this.props
    if (get(cycle, PROPERTY) !== CUSTOM_RUN_COUNT_VALUE) {
      this.setProperty()
    }
  }

  setProperty = () => {
    const {onChange} = this.props
    onChange(null, PROPERTY, CUSTOM_RUN_COUNT_VALUE)
  }

  render() {
    const {cycle} = this.props

    return (
      <Hidden
        name={PROPERTY}
        value={get(cycle, PROPERTY)} />
    )
  }
}


export default CustomPeriodValue
